import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface CheckoutSessionInfo {
  public_key: string;
  session_id: string;
}

const checkoutSession: Module<CheckoutSessionInfo, RootState> = {
  namespaced: true,
  state: {
    public_key: '',
    session_id: '',
  },
  mutations: {
    setValue(state: CheckoutSessionInfo, value: CheckoutSessionInfo): void {
      Object.assign(state, value);
    },
  },
  getters: {
    publicKey(state: CheckoutSessionInfo): string {
      return state.public_key;
    },
    sessionId(state: CheckoutSessionInfo): string {
      return state.session_id;
    },
  },
};

export default checkoutSession;
